import { Bell, Plus } from "lucide-react";
import { pushSupported } from "@/lib/push";
import { ReminderEditor } from "@/components/ReminderEditor";
import { useReminders } from "@/hooks/useReminders";
import { PushEnableCard, PointsInfo, ReminderItem, ReminderStats } from "@/components/reminders/ReminderListParts";
import { TimezoneRow } from "@/components/reminders/TimezoneRow";

export function RemindersPanel({ habits, presetHabitId, onPresetConsumed }) {
  const rm = useReminders(presetHabitId, onPresetConsumed);
  const { data, editing, setEditing } = rm;

  return (
    <div className="space-y-4" data-testid="reminders-panel">
      <div className="warm-card p-6 space-y-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Bell className="w-5 h-5 text-amber-700" />
            <h3 className="font-display text-lg font-bold text-stone-900">Reminders</h3>
          </div>
          {habits.length > 0 && (
            <button data-testid="new-reminder-btn" onClick={() => setEditing({ preset: habits[0].id })} className="inline-flex items-center gap-1 text-xs font-semibold text-amber-800 hover:text-amber-900">
              <Plus className="w-3.5 h-3.5" /> New
            </button>
          )}
        </div>

        {(pushSupported() || data.push_subscribed) && <PushEnableCard subscribed={data.push_subscribed} enabling={rm.enabling} onEnable={rm.enable} />}
        <TimezoneRow reminders={data.reminders} onChanged={rm.reload} />
        <PointsInfo />

        {data.reminders.length === 0 && !editing && (
          <p className="text-sm text-stone-500">No reminders yet. Add one to a habit and choose how firmly you'd like to be nudged.</p>
        )}

        <ul className="space-y-2">
          {data.reminders.map((r) => (
            <ReminderItem key={r.id} r={r} onToggle={rm.toggleActive} onTest={rm.test} onEdit={(item) => setEditing({ item })} onRemove={rm.remove} />
          ))}
        </ul>

        <ReminderStats history={rm.history} />
      </div>

      {editing && habits.length > 0 && (
        <ReminderEditor key={editing.item?.id || `${editing.preset}-${editing.time || ""}`} habits={habits} initial={rm.initialFor()}
          channelSetup={data.channel_setup} onSave={rm.save} onCancel={() => setEditing(null)} />
      )}
    </div>
  );
}
